import { MessageCircle } from "lucide-react";

const NUMBER = "2348139771270";

export default function WhatsAppFab({ text = "Hello Jay's Veterinary, I'd like to book a consultation for my pet." }) {
  const href = `https://wa.me/${NUMBER}?text=${encodeURIComponent(text)}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer"
       className="fab btn-whatsapp" aria-label="Chat on WhatsApp" data-testid="whatsapp-fab">
      <MessageCircle size={26} />
    </a>
  );
}
